import React from 'react';
import { useTranslation } from 'react-i18next';
import ScreenUpDown from "../ui/ScreenUpDown";
import {portfolioData} from "../../constants/data";
import SlideUp from "../ui/SlideUp";


const Portfolio = () => {
  const { t } = useTranslation();
  return (
    <div className="md:pb-40">
      <SlideUp>
        <div className="md:w-theme-container w-mobile-container mx-auto md:pt-32 mb-20 lg:mb-5 text-center text-2xl">{t('common.portfolio')}</div>
      </SlideUp>
      {portfolioData.map((data, index) => (
        <ScreenUpDown key={data?.id} props={data} index={index}/>
      ))}
    </div>
  );
};

export default Portfolio;